/**
 * @author Ariel
 * @description 经销商管理页面配置
 * @createDate 2020/1/9
 * @updateDate 2020/3/11
 */
import React from "react";
import { WizTableForm } from "../../common";
import moment from "moment";
import { component_tool } from "../../../tool";
let { WizDataTable, WizButton } = component_tool

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
let componentName = 'dealer'

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const columns = (e) => {
  return [
    {
      name: 'id',
      formItem: { type: 'hidden' }
    },
    {
      name: 'delFlag',
      formItem: { type: 'hidden' }
    },
    {
      name: "dealerParentInfo",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: '组织',
      name: 'organizationList',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '经销商名称',
      name: 'name',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '经销商简称',
      name: 'shortName',
      tableItem: {}
    },
    {
      title: '开店状态',
      name: 'state',
      dataIndex: 'state',
      dict: [
        { code: 1, codeName: '开业' },
        { code: 2, codeName: '停业' },
        { code: 3, codeName: '待开业' }
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '销售代码',
      name: 'preSalesNumber',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '售后代码',
      name: 'afterSalesNumber',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '站点类型',
      name: 'type',
      dict: [
        {code: 1, codeName: '经销商'},
        {code: 2, codeName: '服务商'},
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {

      },
    },
    {
      title: '组织',
      name: 'orgName',
      tableItem: {
        render: (text, record) => {
          let {brandName,areaName} = record
          return record?.orgName
        }
      }
    },
    {
      title: '省份',
      name: 'province',
      tableItem: {}
    },
    {
      name: 'city',
      formItem: { type: 'hidden' }
    },
    {
      name: 'region',
      formItem: { type: 'hidden' }
    },
    {
      title: '开店状态',
      name: 'state',
      dataIndex: 'state',
      tableItem: {},
      dict: [
        { code: 1, codeName: '开业' },
        { code: 2, codeName: '停业' },
        { code: 3, codeName: '待开业' }
      ]
    },
    {
      title: '开店时间',
      name: 'openTime',
      tableItem:{
        render: (text, record) => {
          return formatterDate(text)
        }
      }
    },
    {
      title: '在职人数',
      name: 'onJobNumber',
      tableItem: {
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip={text}
              onClick={() => {
                e.jumpPage && e.jumpPage(
                  'push',
                  '/org/dealer/lookPositionNumber',
                  { searchProps: { org: [record] } }
                )
              }}>
              {text}
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    },
    {
      title: '省份',
      name: 'province',
      searchItem: {}
    },
    {
      title: '城市',
      name: 'city',
      searchItem: {}
    },
    {
      title: '地址',
      name: 'address',
      searchItem: {
        width: 800
      }
    },
    {
      title: '开店时间',
      name: 'openTime',
      searchItem: {
        type: 'date~',
        format: 'YYYY-MM-DD',
      }
    }
  ]
};

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(e),
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['openTime'] && value['openTime'].length === 2) {
              value['openStartTime'] = moment(value['openTime'][0]).format("YYYY-MM-DD 00:00:00")
              value['openEndTime'] = moment(value['openTime'][1]).format("YYYY-MM-DD 23:59:59")
            }
            // delete value['openTime']
            return value
          },
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/dealer/dealerDetailAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update','look'],
        rowOperateProps: {
          width: 120,
          fixed: 'right',
        },
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/org/dealer/dealerDetailUpd'
              }
            }
          },
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/org/dealer/dealerInfoDetail'
              }
            }
          }
        ],
        commonOperate: {
          delete: true
        }
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
